import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String, title: String }

  async share() {
    const url  = this.urlValue
    const title = this.titleValue

    if (navigator.share) {
      try {
        await navigator.share({ title, url })
      } catch (e) {
        if (e.name !== "AbortError") this.copyToClipboard(url)
      }
    } else {
      this.copyToClipboard(url)
    }
  }

  copyToClipboard(url) {
    navigator.clipboard.writeText(url).then(() => this.showConfirm())
  }

  showConfirm() {
    this.element.classList.add("is-copied")
    setTimeout(() => this.element.classList.remove("is-copied"), 2000)
  }
}
